import localStore from '$lib/stores/localStore';

const volume = localStore('volume', 50);
volume.subscribe(v => volume.value = v);

export default volume;
